export default __webpack_public_path__ + "static/media/image-loon-bag.8034e726.svg";